import type { PackageJson } from '@wix/cli-fs';

export function setScripts(
  packageJson: PackageJson,
  scripts: Record<string, string>
) {
  packageJson.scripts ??= {};

  for (const [key, value] of Object.entries(scripts)) {
    packageJson.scripts[key] = value;
  }
}
